import { render, staticRenderFns } from "./index.vue?vue&type=template&id=271d5054&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=271d5054&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d5054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271d5054')) {
      api.createRecord('271d5054', component.options)
    } else {
      api.reload('271d5054', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=271d5054&scoped=true", function () {
      api.rerender('271d5054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms/smsTemplate/index.vue"
export default component.exports